import { omit } from 'ramda';

import {
  type DatoButtonBlock,
  type DatoIconBlock,
  type DatoTargetBlock,
} from '@/lib/datocms/types';
import { type DatoButtonLikeBlock, type DatoFlatButtonBlock } from '../types';

const isFlatButtonBlock = (
  button: DatoButtonLikeBlock
): button is DatoFlatButtonBlock => button.__typename === 'FlatButtonRecord';

export const getButtonTarget = (
  button: DatoButtonLikeBlock
): DatoTargetBlock | null | undefined => {
  if (isFlatButtonBlock(button)) {
    const { anchor, blogArticle, gaEvent, io, link, route } = button;

    return {
      anchor,
      blogArticle,
      ...(gaEvent && { gaEvent: [gaEvent] }),
      io,
      link,
      route,
    };
  }

  return button.target?.[0];
};

export const getButtonIcon = (
  button: DatoButtonLikeBlock
): DatoIconBlock | null | undefined => {
  if (isFlatButtonBlock(button)) {
    const { iconColor, iconName, iconPlacement } = button;
    if (!iconName) return null;

    return {
      color: iconColor,
      name: iconName,
      placement: iconPlacement,
    };
  }

  return button.icon?.[0];
};

export const overrideButtonLink = (
  button: DatoButtonBlock,
  link?: string
): DatoButtonBlock => {
  if (!link || !button.target?.[0]) return button;

  return {
    ...button,
    target: [{ ...omit(['route'], button.target[0]), link }],
  };
};
